export default __webpack_public_path__ + "47e6b4e31320124d30d907e543bb07f3.jpg";